import * as THREE from 'three'

export default class AssetLoader {
    constructor() {
        // 1. 建立 Three.js 原生的載入管理器
        this.loadManager = new THREE.LoadingManager()

        // 2. 將 ImageBitmapLoader 綁定到這個管理器
        this.bitmapLoader = new THREE.ImageBitmapLoader(this.loadManager)
        this.bitmapLoader.setOptions({ imageOrientation: 'flipY' })

        this.textures = {}
        this.bitmaps = {}
    }

    /**
     * 載入所有資源
     */
    load(items, onProgress) {
        return new Promise((resolve, reject) => {
            const total = items.length
            if (total === 0) {
                onProgress?.(1)
                resolve()
                return
            }

            this.loadManager.onProgress = (url, itemsLoaded, itemsTotal) => {
                onProgress?.(itemsLoaded / itemsTotal)
            }

            this.loadManager.onLoad = () => {
                resolve()
            }

            this.loadManager.onError = (url) => {
                if (url === '') {
                    return
                }
                console.error(`載入出錯的檔案: ${url}`)
                reject(new Error(`Failed to load: ${url}`))
            }

            items.forEach((item) => {
                this.bitmapLoader.load(item.src, (imageBitmap) => {
                    const texture = new THREE.CanvasTexture(imageBitmap)
                    texture.flipY = false

                    this.bitmaps[item.id] = imageBitmap
                    this.textures[item.id] = texture
                })

                const warmImg = new Image()
                warmImg.src = item.src
                warmImg.decode?.().catch(() => {})
            })
        })
    }

    // 把所有已載入的貼圖預先上傳到 GPU（否則第一次 render 該貼圖那幀才同步上傳 → 切換卡頓）
    // 同時開啟各向異性過濾，避免 Carousel 卡片轉到側面（斜角觀看）時貼圖因 Mipmap 均向模糊而糊掉
    warmUp(renderer) {
        const maxAnisotropy = renderer.capabilities.getMaxAnisotropy()

        Object.values(this.textures).forEach((texture) => {
            texture.anisotropy = maxAnisotropy
            return renderer.initTexture(texture)
        })
    }

    getTexture(id) {
        return this.textures[id] ?? null
    }
    getBitmap(id) {
        return this.bitmaps[id] ?? null
    }

    dispose() {
        Object.values(this.textures).forEach((texture) => {
            return texture.dispose()
        })
        Object.values(this.bitmaps).forEach((bitmap) => {
            return bitmap.close?.()
        })
        this.textures = {}
        this.bitmaps = {}
    }
}
